import styles from "../Users/Carts/DeleteConfirmation.module.css";
import Backdrop from "../Catalogs/Dialog/Backdrop";

export const GroupDeleteConfirmation = ({
  show,
  onCancel,
  onConfirm,
  groupName,
}) => {
  if (!show) return null;

  return (
    <div>
      <Backdrop show={show} switch={onCancel} />
      <div className={styles.deleteDialog}>
        <h2 className={styles.deleteTitle}>Delete Group</h2>
        <p className={styles.deleteMessage}>
          This action will permanently delete the group
          {groupName ? ` "${groupName}"` : ""}. You can't undo this.
        </p>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.deleteButton} onClick={onConfirm}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};
